import phone1 from "../assets/images/app/Profesional home.png";
// import phone2 from '../assets/images/app/Home Paciente.png'
import phone2 from "../assets/images/app/Profesional modelo.png";
import phone3 from "../assets/images/app/Profesional musculo.png";
import phone4 from "../assets/images/app/profesional bilbioteca.png";
import phone5 from "../assets/images/app/Profesional asignar rutina.png";
import phone6 from "../assets/images/app/Paciente rutinas.png";
import phone7 from "../assets/images/app/Paciente Chat.png";

import client1 from "../assets/images/client/01.jpg";
import client2 from "../assets/images/client/02.jpg";
import client3 from "../assets/images/client/03.jpg";
import client4 from "../assets/images/client/04.jpg";
import client5 from "../assets/images/client/05.jpg";
import client6 from "../assets/images/client/06.jpg";

import company1 from "../assets/images/client/amazon.svg";
import company2 from "../assets/images/client/google.svg";
import company3 from "../assets/images/client/lenovo.svg";
import company4 from "../assets/images/client/paypal.svg";
import company5 from "../assets/images/client/shopify.svg";
import company6 from "../assets/images/client/spotify.svg";

import {
  FiEye,
  FiFeather,
  FiHeart,
  FiMaximize,
  FiMessageCircle,
  FiMonitor,
  FiPieChart,
  FiSmartphone,
  FiUserCheck,
} from "react-icons/fi";

export const feature = [
  {
    icon: FiMaximize,
    title: "Gestión completa",
    desc: "Crea, edita y organiza rutinas y ejercicios desde un único panel.",
    active: true,
  },
  {
    icon: FiMessageCircle,
    title: "Chat en tiempo real",
    desc: "Comunicación rápida entre profesional y paciente con contexto de rutinas y ejercicios.",
    active: false,
  },
  {
    icon: FiEye,
    title: "Modelo 3D profesional",
    desc: "Genera y adapta ejercicios desde una base precargada para crear planes personalizados.",
    active: true,
  },
  {
    icon: FiPieChart,
    title: "Seguimiento del progreso",
    desc: "Visualiza avances y mejora la adherencia de tus clientes.",
    active: false,
  },
];

export const feature2 = [
  {
    icon: FiMonitor,
    title: "Uso en cualquier dispositivo",
    desc: "La experiencia se adapta a móvil y escritorio para trabajo diario.",
  },
  {
    icon: FiFeather,
    title: "Interfaz limpia",
    desc: "Diseño claro para ejecutar tareas rápidas sin fricción.",
  },
  {
    icon: FiEye,
    title: "Visualización detallada",
    desc: "Revisa rutinas y ejercicios con información precisa.",
  },
];
export const feature3 = [
  {
    icon: FiUserCheck,
    title: "Flujo validado",
    desc: "Procesos pensados para operación profesional real.",
  },
  {
    icon: FiSmartphone,
    title: "Experiencia responsive",
    desc: "Clientes y profesionales acceden desde su dispositivo preferido.",
  },
  {
    icon: FiHeart,
    title: "Mejor adherencia",
    desc: "Comunicación y seguimiento para sostener el plan de trabajo.",
  },
];

export const screenshotImg = [
  phone1,
  phone2,
  phone3,
  phone4,
  phone5,
  phone6,
  phone7,
];

export const faq = [
  {
    id: 1,
    title: "¿Cómo funciona Therapy Connect?",
    desc: "Registras tus clientes, asignas rutinas y haces seguimiento continuo desde un solo panel.",
  },
  {
    id: 2,
    title: "¿Está pensado para personal trainers y kinesiólogos?",
    desc: "Sí. El flujo contempla ambos perfiles y el trabajo con diferentes tipos de clientes.",
  },
  {
    id: 3,
    title: "¿Cómo solicito la demo?",
    desc: "Puedes enviar tu solicitud desde el formulario de contacto y coordinamos una presentación.",
  },
  {
    id: 4,
    title: "¿Qué incluye la demostración?",
    desc: "Incluye gestión de rutinas, ejercicios, mensajería y seguimiento de progreso con casos reales.",
  },
];

export const clientData = [
  {
    image: client1,
    name: "Carla Muñoz",
    position: "Personal Trainer",
    desc: `" Therapy Connect me permitió organizar mis rutinas y dar seguimiento semanal sin perder tiempo. "`,
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
  {
    image: client2,
    name: "Javier Rojas",
    position: "Kinesiólogo",
    desc: `" La comunicación con pacientes mejoró mucho gracias al chat y al contexto de ejercicios. "`,
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
  {
    image: client3,
    name: "Natalia Pérez",
    position: "Directora de Centro",
    desc: `" Ahora mi equipo puede escalar la atención manteniendo calidad y control de cada plan. "`,
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
  {
    image: client4,
    name: "Tomás Herrera",
    position: "Entrenador",
    desc: `" La vista de rutinas y recordatorios hace muy simple mantener la adherencia del cliente. "`,
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
  {
    image: client5,
    name: "Andrea Silva",
    position: "Kinesióloga",
    desc: `" La biblioteca de ejercicios y el seguimiento clínico nos ayudó a estandarizar protocolos. "`,
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
  {
    image: client6,
    name: "Felipe Soto",
    position: "Coordinador Deportivo",
    desc: `" Es una solución práctica para centros que quieren mostrar una experiencia moderna en sus demos. "`,
    rate: [
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
      "mdi mdi-star",
    ],
  },
];

export const companyData = [
  company1,
  company2,
  company3,
  company4,
  company5,
  company6,
];
